export class CodemationTelemetryMetricNames {
  static readonly agentTurns = "codemation.ai.turns";
  static readonly agentToolCalls = "codemation.ai.tool_calls";
  static readonly gmailMessagesEmitted = "codemation.gmail.messages_emitted";
  static readonly gmailAttachments = "codemation.gmail.attachments";
  static readonly gmailAttachmentBytes = "codemation.gmail.attachment_bytes";
}
